import { all, takeLatest } from "redux-saga/effects";
import {
  SHIPPING_LIST,
  SHIPPING_DETAILS,
  ADD_SHIPPING,
  UPDATE_SHIPPING,
  DELETE_SHIPPING,
} from "../actions/shipping.actions.types";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { successMessage } from "../../utilities/notification";

const call = Effects.call;

function* getShippingList({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "shipping-methods/list",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* shippingDetails({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `shipping-methods/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* addShipping({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "shipping-methods",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* updateShipping({ payload: { id, data, callback } }) {
  const payload = {
    data,
    method: "put",
    url: `shipping-methods/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* deleteShipping({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `shipping-methods/${id}?force=false`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* Shipping() {
  yield all([
    takeLatest(SHIPPING_LIST, getShippingList),
    takeLatest(SHIPPING_DETAILS, shippingDetails),
    takeLatest(ADD_SHIPPING, addShipping),
    takeLatest(UPDATE_SHIPPING, updateShipping),
    takeLatest(DELETE_SHIPPING, deleteShipping),
  ]);
}

export default Shipping;
